/**
 * Where ptc-core keeps `columnFilterOps` (web/src/components/), so the files copied from core at 7d1f5f9 for C86
 * (listFilters/picklistSelection.ts and its test, which import '../columnFilterOps') stay byte-identical, as supervision did.
 * This repo has no operator/value filter record, so the token is defined here, once.
 *
 * "Has no value" inside a lookup column's `in`/`notIn` value list (fleet filter contract v3 §16.8 / C86). THE FLEET'S value,
 * identical to ptc-core's and tax-lifecycle's, so a saved view means the same thing in every app.
 */
export const NO_VALUE_TOKEN = '__TL_NO_VALUE__';
